import { localStorageKey } from './constant';
import { getCookie } from './api_utils';

export const builderSurfaceMultiPartHeader = (projectId) => {
  const environment = localStorage.getItem(localStorageKey.ENVIRONMENT);
  const token = getCookie('token');
  const headers = { 'Content-Type': 'multipart/form-data', 'x-project-id': projectId };
  if (environment) {
    headers['x-project-env'] = environment.toLowerCase();
  }
  if (token) {
    headers['token'] = `Bearer ${token}`;
  }
  return { headers };
};

export const builderSurfaceJsonContentHeader = (projectId, userIp = '') => {
  const environment = localStorage.getItem(localStorageKey.ENVIRONMENT);
  const token = getCookie('token');
  const headers = {
    'Content-Type': 'application/json',
    'x-project-id': projectId,
  };
  if (environment) {
    headers['x-project-env'] = environment.toLowerCase();
  }
  if (token) {
    headers['token'] = `Bearer ${token}`;
  }
  if (userIp) {
    headers['userIp'] = userIp;
  }
  return { headers };
};
